<template>
    <div class="col-12 col-md-12 col-lg-10 col-xl-10">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
                <div class="tit text-center">
                    <img src="/static/assets/images/ico-complete.svg" style="margin-bottom:40px; width:60px;" alt="icone arquivo">
                    <h1>
                        <span>Seu perfil de investimento é:</span> {{suitability.Tipo}}
                    </h1>
                    <div>
                        <p class="nome">
                            Parabéns, <strong>{{suitability.Nome}}</strong>.
                        </p>
                        <p v-html="texto">

                        </p>
                        <p class="obs">
                            Juntos vamos reinventar o sistema bancário ultrapassado e garantir um melhor negócio para todos.
                        </p>

                       <router-link to="/investimentos/oportunidades" class="btn btn-lg btn-primary" title="Oportunidades abertas">Oportunidades abertas <img src="/static/assets/images/angle-right.svg"></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    /* eslint-disable */
    import HubConsultaClient from '../../utils/hub-consulta-client.js'

    export default {
        data()
        {
                return {texto:""};
        },
        props: {
            suitability: { required: true, type: Object }
        },
        methods: {

        },
        created() {

            if(this.suitability.Tipo == "Conservador")
            {
                this.texto = `Verificamos que você busca rendimentos modestos, o investidor conservador possui a segurança como referência para as suas aplicações, assumindo os menores riscos possíveis. Em razão da sua baixa tolerância ao risco, mantém em sua carteira percentual reduzido de produtos de renda variável, dando preferência aos produtos de renda fixa.
                            <br>Dessa forma, esteja ciente dos riscos e benefícios de investir através do empréstimo coletivo (peer-to-peer lending).
                            <br>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
            }
            if(this.suitability.Tipo == "Moderado")
            {
                this.texto = `Você procura equilibrar rentabilidade com risco. É um investidor que prefere a segurança da renda fixa, mas também aplica parte de seus recursos em renda variável, visando retornos acima da média do mercado. Por isso, ficamos felizes em informar que você já pode começar seus investimentos conosco. Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
            }

            if(this.suitability.Tipo == "Arrojado")
            {
                this.texto = `Você busca sempre alta rentabilidade, mesmo que corra riscos de perder parte do patrimônio. Assume posições mais concentradas e especulativas como forma de alcançar um maior retorno.
                            <br/>Você tem ciência dos riscos e benefícios de investir atráves do empréstimo coletivo (peer-to-peer lending).
                            <br/>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
            }

            if(this.suitability.Tipo == "Super Agressivo" || this.suitability.Tipo == "Agressivo")
            {
                this.texto = `Você possui total conhecimento e amplo domínio dos produtos de investimento. Você busca retornos muito expressivos no curto prazo, suportando quaisquer riscos.
                            <br/>Você tem ciência dos riscos e benefícios de investir atráves do empréstimo coletivo (peer-to-peer lending).
                            <br/>Esperamos que este seja o começo de uma parceria de muito sucesso entre você e a IOUU.`
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/InformationSuitability/ConfirmacaoPerfil.vue